import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { LogOut, User2 } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_volunteer-dispatch-6/artifacts/8p87dbov_hope-to-home-350x66.png";

export default function Header({ variant = "public" }) {
  const { user, logout } = useAuth();
  const { pathname } = useLocation();

  return (
    <header
      data-testid="app-header"
      className="sticky top-0 z-40 backdrop-blur-md bg-white/85 border-b border-slate-200/70"
    >
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-3 flex items-center justify-between gap-4">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-3 focus-ring rounded-md">
          <img
            src={LOGO_URL}
            alt="Hope to Home Furniture Resource"
            className="h-9 sm:h-10 w-auto"
          />
          <span className="hidden sm:block text-xs uppercase tracking-[0.18em] text-slate-500 font-semibold border-l border-slate-200 pl-3">
            Volunteer Signup
          </span>
        </Link>

        <nav className="flex items-center gap-1 sm:gap-2">
          {variant === "public" && user && user.role !== "admin" && (
            <>
              <span className="hidden sm:inline-flex items-center gap-1.5 text-sm text-slate-500 px-2">
                <User2 className="w-4 h-4" /> {user.name || user.email}
              </span>
              <button
                onClick={logout}
                data-testid="logout-button"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-brand-blue px-3 py-2 rounded-md focus-ring"
              >
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </>
          )}
          {variant === "public" && user && user.role === "admin" && (
            <>
              <Link
                to="/admin"
                data-testid="nav-to-admin"
                className="text-sm font-medium text-brand-blue hover:text-brand-blue-dark px-3 py-2 rounded-md focus-ring"
              >
                Dashboard
              </Link>
              <button
                onClick={logout}
                data-testid="logout-button"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-brand-blue px-3 py-2 rounded-md focus-ring"
              >
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </>
          )}
          {variant === "admin" && user && (
            <>
              <Link
                to="/"
                data-testid="nav-to-board"
                className="text-sm font-medium text-slate-600 hover:text-brand-blue px-3 py-2 rounded-md focus-ring"
              >
                Board
              </Link>
              <Link
                to="/admin"
                data-testid="nav-admin-overview"
                className={`text-sm font-medium px-3 py-2 rounded-md focus-ring ${pathname === "/admin" ? "text-brand-blue" : "text-slate-600 hover:text-brand-blue"}`}
              >
                Dashboard
              </Link>
              <span className="hidden sm:inline-flex items-center gap-1.5 text-sm text-slate-500 px-2">
                <User2 className="w-4 h-4" />
                {user.email}
              </span>
              <button
                onClick={logout}
                data-testid="logout-button"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-slate-600 hover:text-brand-blue px-3 py-2 rounded-md focus-ring"
              >
                <LogOut className="w-4 h-4" /> Logout
              </button>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
